import { useEffect, useState } from 'react';
import { getFormDateRangeFieldsDefaultTime } from '../../common/helpers/get-form-date-range-fields-default-time';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useSelectedUnitHistoryUnitOption } from '../context/hooks';
import { UnitHistoryForm } from '../types';
import { timeRangeValueToDateRange } from '../utils';

export function useUnitHistoryFormEditEffects() {
    const { form } = useIntegratedForm<UnitHistoryForm>();
    const unitOption = form.watch('unitOption');
    const userOption = form.watch('userOption');
    const timeRangeOption = form.watch('timeRangeOption');
    const [showDateRangeInput, setShowDateRangeInput] = useState(false);

    useEffect(() => {
        if (unitOption && form.getValues().userOption) {
            form.setValue('userOption', null);
        }
    }, [unitOption, form]);

    useEffect(() => {
        if (userOption && form.getValues().unitOption) {
            form.setValue('unitOption', null);
        }
    }, [userOption, form]);

    const selectedUnitOption = useSelectedUnitHistoryUnitOption();
    useEffect(() => {
        form.setValue('unitOption', selectedUnitOption);
    }, [form, selectedUnitOption]);

    useEffect(() => {
        if (timeRangeOption.value === 'CUSTOM') {
            form.setValue('dateRange', getFormDateRangeFieldsDefaultTime());
            setShowDateRangeInput(true);
        } else {
            form.setValue('dateRange', timeRangeValueToDateRange(timeRangeOption.value));
            setShowDateRangeInput(false);
        }
    }, [form, timeRangeOption]);

    return { showDateRangeInput };
}
